// * Bootstrap libraries
import "./_bootstrap";

// * Any other global site-wide JavaScript should be placed below.

(function($) {
    $(document).ready(function() {

        // всплывашки с формами
        $('.fancy-form').fancybox({
            touch: false
        });

        // photobox
        $('.products_photo_main').photobox('a',{ time:0 });
        $('.field--name-field-block-photos').photobox('a',{ time:0 });
        $('.field--name-field-solutions-place').photobox('a',{ time:0 });
        $('.field--name-field-product-packs').photobox('a',{ time:0 });
        $('.node--type-article p').photobox('a',{ time:0 });

        // слайдер на главной
        $('#slider .field--name-field-paragraph-block').slick({
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false
        });

        // карусель новостей
        $('.view-news-second .view-content').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '.next_news',
            prevArrow: '.prev_news',
            responsive: [
                { breakpoint: 768,
                    settings: { slidesToShow: 1 } },
                { breakpoint: 565,
                    settings: "unslick" },
            ]
        });

        // карусель вакансий
        $('.view-vacancy .view-content').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            arrows: true,
            nextArrow: '.next_vacancy',
            prevArrow: '.prev_vacancy'
        });

        if ($('body').hasClass('path-taxonomy')) {
            var page_title = document.getElementsByTagName('h1')[0];
            var page_title_clr = page_title.innerText || page_title.textContent;
            $('.breadcrumb .active').text(page_title_clr);
        }

        // more button
        $('#more_producs_type').click(function() {
            $('.view-product-type-icons .view-content').closest(".view-content").toggleClass("view-content--opened");
            if ($(this).text() == "Свернуть") {
                $(this).text("Показать все продукты под упаковку");
            } else {
                $(this).text("Свернуть");
            }
        });

        // gallery products
        $('.products_photo_main').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: false,
            autoplay: false,
            arrows: false,
            pauseOnHover: false,
            asNavFor: '.products_photo_nav',
            onAfterChange:function(slickSlider,i){
                $('.products_photo_nav .slick-slide').removeClass('slick-active');
                $('.products_photo_nav .slick-slide').eq(i).addClass('slick-active');
            }

        });
        $('.products_photo_nav').slick({
            slidesToShow: 7,
            slidesToScroll: 1,
            infinite: true,
            variableWidth: true,
            asNavFor: '.products_photo_main',
            dots: false,
            autoplay: false,
            pauseOnHover: false,
            useTransform: false,
            focusOnSelect: true,
            arrows: false,
        });
        //set active class to first slide
        $('.products_photo_nav .slick-slide').eq(0).addClass('slick-active');

    });
})(jQuery);